<template lang="html">
  <div class="">
    <el-row :gutter="10" type="flex">
      <el-col :span="24">
        <div class="grid-content">
          <div class="item">
            <el-button
              plain
              type="primary"
              icon="el-icon-refresh"
              size="small"
              @click="syncFeed"
              :loading="syncFeedLoading"
              :disabled="syncFeedDisabled"
            >
              从荔枝同步公播节目
            </el-button>
          </div>
          <div class="item">
            <router-link :to="{name: 'CreateEpisode'}">
              <el-button
                plain
                type="primary"
                icon="el-icon-mic"
                size="small"
              >
                创建私房课付费节目
              </el-button>
            </router-link>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="container">
      <!-- <div class="h3">单集</div> -->
      <el-table
        border
        stripe
        v-loading="tableDataLoading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="编号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="title"
          label="单集标题">
        </el-table-column>
        <el-table-column
          prop="created"
          label="创建时间"
          width="230"
          :formatter="createdFormatter"
        >
        </el-table-column>
        <el-table-column
          prop="published"
          label="状态"
          width="120"
          :formatter="publishedFormatter"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row, $event)"
            >
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :total="totalCounts">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../router'
  import { Message } from 'element-ui'
  import { MessageBox } from 'element-ui'
  export default {
    data() {
      return {
        tableDataLoading: true,
        tableData: [],
        totalCounts: 0,
        syncFeedLoading: false,
        syncFeedDisabled: false
      }
    },
    methods: {
      getEpisodes (offset) {
        let that = this
        let params = {
          offset: offset,
          slug: that.$route.params.slug,
          includeDraft: true
        }
        that.$api.episode.list(params).then(res => {
          window.console.log(res)
          that.tableData = res.data.results
          that.totalCounts = res.data.count
          that.tableDataLoading = false
        })
      },
      handleClick(row) {
        window.console.log(row);
      },
      handleCurrentChange(val) {
        window.console.log(`当前页: ${val}`)
        this.getEpisodes(val * 10 - 10)
      },
      handleEdit(index, row, event) {
        let that = this
        window.console.log("编辑")
        window.console.log(event.target)
        window.console.log(event.currentTarget)
        window.console.log(index)
        window.console.log(row)
        let showSlug = row.show
        let episodeId = row.id
        that.$api.episode.private_cdn_exist(episodeId).then(res => {
          window.console.log("音频文件是否已经上传")
          window.console.log(res)
          if (res.data.exist) {
            router.push({
              name: 'UpdateEpisode',
              params: {
                slug: showSlug,
                id: episodeId
              }
            })
          } else {
            window.console.log("音频文件还没有上传到云端")
            MessageBox.alert('公播节目同步未完成，请稍候；或点击“从荔枝同步公播节目”进行同步', '请稍侯...')
          }
        })
      },
      syncFeed() {
        let that = this
        window.console.log("同步")
        that.syncFeedLoading = true
        that.syncFeedDisabled = true
        that.tableDataLoading = true
        let showSlug = that.$route.params.slug
        that.$api.show.syncFeed(showSlug).then(res => {
          window.console.log("同步成功")
          window.console.log(res)
          that.syncFeedLoading = false
          that.syncFeedDisabled = false
          let message = ''
          let added_count = res.data.added_entries.length
          let update_count = res.data.update_entries.length
          if (added_count > 0 || update_count > 0) {
            if (added_count > 0) {
              message += `<p>新增 ${added_count} 个单集：</p>`
              for (let i = 0; i < res.data.added_entries.length; i++) {
                message += `<p style="margin-top:5px;">${res.data.added_entries[i]}</p>`
              }
            }
            if (update_count > 0) {
              message += `<p>更新 ${update_count} 个单集：</p>`
              for (let i = 0; i < res.data.update_entries.length; i++) {
                message += `<p style="margin-top:5px;">${res.data.update_entries[i]}</p>`
              }
            }
            Message.success({
              dangerouslyUseHTMLString: true,
              message: message
            })
          } else {
            Message.info({
              message: "同步完毕，没有更新内容"
            })
          }
          let offset = 0
          this.getEpisodes(offset)
        })
      },
      createdFormatter (row, column, cellValue, index) {
        window.console.log("创建时间格式化：")
        window.console.log(row)
        window.console.log(column)
        window.console.log(cellValue)
        window.console.log(index)
        let date = new Date(parseInt(cellValue)*1000)
        date = date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + '日'
        // let date = new Date(
        //   parseInt(cellValue)*1000).toLocaleDateString()
        let time = new Date(
          parseInt(cellValue)*1000).toLocaleTimeString()
        return `${date}${time}`
      },
      publishedFormatter (row, column, cellValue, index) {
        window.console.log("publishedFormatter:")
        window.console.log(row)
        window.console.log(column)
        window.console.log(cellValue)
        window.console.log(index)
        if (cellValue) {
          return '已发布'
        } else {
          return '草稿'
        }
      }
    },
    mounted () {
      let offset = 0
      this.getEpisodes(offset)
    }
  }
</script>

<style lang="css" scoped>
  .pagination {
    width: 100%;
    margin-top: 15px;
    text-align: center;
  }
  .grid-content {
      margin-bottom:15px;
    display: flex;
  }
  .item {
    margin-right: 10px;
  }
</style>
